/**
 * Wraps a not-yet-built feature: renders the real content blurred and
 * non-interactive behind a "Coming soon" badge. Mirrors fresh-dashboard's
 * ComingSoonOverlay so prototype code drops in unchanged.
 *
 * When `active` is false it renders children untouched, so the same call
 * site can flip to the real feature later without restructuring.
 */
export function ComingSoonOverlay({ active, title, icon: Icon, children, badgeText = 'Coming soon' }) {
	if (!active) return children;

	return (
		<div className="relative">
			<div aria-hidden className="pointer-events-none select-none opacity-60 blur-[3px]">
				{children}
			</div>
			<div className="absolute inset-0 flex items-center justify-center p-3">
				<div
					className="flex flex-col items-center gap-2 rounded-2xl border border-border/60 px-4 py-3 text-center backdrop-blur-sm"
					style={{
						backgroundImage: 'linear-gradient(rgba(255,255,255,0.45), rgba(255,255,255,0.45)), var(--gradient-soft)'
					}}
				>
					{title ? (
						<span className="inline-flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">
							{Icon ? <Icon className="h-3 w-3" strokeWidth={2.2} /> : null}
							{title}
						</span>
					) : null}
					<span className="inline-flex items-center gap-1 rounded-full border border-border bg-accent/40 px-2.5 py-1 text-xs font-semibold text-muted-foreground">
						{badgeText}
					</span>
					<p className="max-w-xs whitespace-pre-line text-xs leading-snug text-muted-foreground">
						{"You're notified once your score is ready."}
					</p>
				</div>
			</div>
		</div>
	);
}
